import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from 'react';
import HomePage from "./Views/HomePage";
import Header from "./Views/Header"; // Import Header globally
import CaseStudyReturns from "./CaseStudies/CaseStudyReturns"; // adjust the path if needed
import CaseStudyAi from "./CaseStudies/CaseStudyAi";
import CaseStudyEco from "./CaseStudies/CaseStudyEco";
import Footer from "./Views/Footer";
const CaseStudy = lazy(() => import("./Views/CaseStudy"));
const Articles = lazy(() => import("./Views/Articles"));
const AboutMe = lazy(() => import("./Views/AboutMe"));



const App = () => {
  return (
    <Router>
      <Header /> {/* This will make the Header appear on all pages */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/case/:slug" element={<CaseStudy />} />
        <Route path="/case/returns" element={<CaseStudyReturns />} />
        <Route path="/case/ai" element={<CaseStudyAi />} />
        <Route path="/case/eco" element={<CaseStudyEco />} />


      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
